<div class="flex-1 d-flex fd-col ai-stretch">
  <ng-container *ngFor="let row of skeletonLayout">
    <div class="flex-1 d-flex fd-row">
      <ngx-skeleton-loader class="card skeleton-tile slim-margin"
        [theme]="{'height': '100%', 'width': '100%', 'background-color': '#f0f3f5'}" *ngFor="let column of row">
      </ngx-skeleton-loader>
    </div>
  </ng-container>
</div>